import Immutable from 'seamless-immutable';
import createReducer from '../../../redux/helpers/createReducer';

const state = {
  wwtkData: [],
  doneActivities: []
};

export default createReducer(state, {
  SET_DONE_WWTK_ITEM: (state, { data }) => {
    const doneActivities = state.doneActivities || [];
    return Immutable({ ...state, doneActivities: [...doneActivities, data] });
  },
});
